import KitSerializer from "../rna-fish/KitSerializer";
var ManualProConsumerKitSerializer = /** @class */ (function () {
    function ManualProConsumerKitSerializer() {
        var _this = this;
        this.setProbeSetState = function (state) {
            _this.probeSetState = state;
        };
        this.setDetect = function (state) {
            _this.detectState = state;
        };
        this.setBuffers = function (state) {
            _this.buffersState = state;
        };
        this.serializeKit = function (comment, sampleType) {
            var _a, _b, _c, _d, _e, _f, _g;
            var probeSetComponent = null;
            var negativeControlProbe = false;
            if (_this.probeSetState) {
                var scaleValue = _this.probeSetState.scale.scaleValue;
                negativeControlProbe = _this.probeSetState.negativeControlProbe;
                probeSetComponent = {
                    _type: 'manual',
                    probeSet: KitSerializer
                        .serializeProbeSet(_this.probeSetState.organism, _this.probeSetState.target, _this.probeSetState.hcrAmplifier, _this.probeSetState.probeLotNumber),
                    scaleValue: scaleValue,
                    channel: 1
                };
            }
            var detectComponent = null;
            var chromogenComponent = null;
            if (_this.detectState) {
                detectComponent = ManualProConsumerKitSerializer.serializeDetect(_this.detectState);
                if (_this.detectState.chromogen.id !== 'NONE') {
                    chromogenComponent = {
                        presetScaleId: (_a = _this.detectState.presetChromogenScale) === null || _a === void 0 ? void 0 : _a.id,
                        chromogenId: _this.detectState.chromogen.id,
                        chromogenBufferId: _this.detectState.chromogen.bufferCompatibility.id,
                        chromogenScaleUl: (_c = (_b = _this.detectState.presetChromogenScale) === null || _b === void 0 ? void 0 : _b.chromogenScaleUl) !== null && _c !== void 0 ? _c : 0,
                        chromogenBufferScaleUl: (_e = (_d = _this.detectState.presetChromogenScale) === null || _d === void 0 ? void 0 : _d.chromogenBufferScaleUl) !== null && _e !== void 0 ? _e : 0,
                        hematoxylinScaleUl: (_g = (_f = _this.detectState.presetChromogenScale) === null || _f === void 0 ? void 0 : _f.hemotoxylinScaleUl) !== null && _g !== void 0 ? _g : 0
                    };
                }
            }
            var buffersComponent = null;
            if (_this.buffersState) {
                buffersComponent = ManualProConsumerKitSerializer.serializeBuffers(_this.buffersState);
            }
            return {
                '_type': 'manual-pro',
                kit: {
                    sampleTypeId: sampleType.id,
                    probeSetComponent: probeSetComponent,
                    detectComponent: detectComponent,
                    buffersComponent: buffersComponent,
                    chromogenComponent: chromogenComponent,
                    comment: comment,
                    negativeControlProbe: negativeControlProbe,
                    starterKit: false
                }
            };
        };
    }
    ManualProConsumerKitSerializer.serializeDetect = function (a) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        var presetScale = a.presetDetectScale;
        return {
            _type: 'pro',
            prefilled: false,
            proDetectPresetScaleId: presetScale === null || presetScale === void 0 ? void 0 : presetScale.id,
            pretreatADewaxUl: (_a = presetScale === null || presetScale === void 0 ? void 0 : presetScale.pretreatADewaxUl) !== null && _a !== void 0 ? _a : 0,
            pretreatBAntigenRetrievalUl: (_b = presetScale === null || presetScale === void 0 ? void 0 : presetScale.pretreatBAntigenRetrievalUl) !== null && _b !== void 0 ? _b : 0,
            pretreatBloxolUl: (_c = presetScale === null || presetScale === void 0 ? void 0 : presetScale.pretreatBloxolUl) !== null && _c !== void 0 ? _c : 0,
            detectAUl: (_d = presetScale === null || presetScale === void 0 ? void 0 : presetScale.detectAUl) !== null && _d !== void 0 ? _d : 0,
            detectBUl: (_e = presetScale === null || presetScale === void 0 ? void 0 : presetScale.detectBUl) !== null && _e !== void 0 ? _e : 0,
            detectBPmol: (_f = presetScale === null || presetScale === void 0 ? void 0 : presetScale.detectBPmol) !== null && _f !== void 0 ? _f : 0,
            detectBConcentration: (_g = presetScale === null || presetScale === void 0 ? void 0 : presetScale.detectBConcentration) !== null && _g !== void 0 ? _g : 0,
            detectCUl: (_h = presetScale === null || presetScale === void 0 ? void 0 : presetScale.detectCUl) !== null && _h !== void 0 ? _h : 0,
            postProcessAUl: (_j = presetScale === null || presetScale === void 0 ? void 0 : presetScale.postProcessAUl) !== null && _j !== void 0 ? _j : 0,
            postProcessBUl: (_k = presetScale === null || presetScale === void 0 ? void 0 : presetScale.postProcessBUl) !== null && _k !== void 0 ? _k : 0,
            preHybridizationUl: (_l = presetScale === null || presetScale === void 0 ? void 0 : presetScale.preHybridizationUl) !== null && _l !== void 0 ? _l : 0,
            channels: [
                {
                    amplifier: a.enzyme.amplifier.id,
                    hapten: a.enzyme.hapten.id,
                    detectAntiHaptenUl: (_m = presetScale === null || presetScale === void 0 ? void 0 : presetScale.detectAntiHaptenUl) !== null && _m !== void 0 ? _m : 0,
                    detectTyramideUl: (_o = presetScale === null || presetScale === void 0 ? void 0 : presetScale.detectTyramideUl) !== null && _o !== void 0 ? _o : 0,
                    detectHrpQuencherUl: (_p = presetScale === null || presetScale === void 0 ? void 0 : presetScale.detectHrpQuencherUl) !== null && _p !== void 0 ? _p : 0,
                    detectEnzymeApUl: (_q = presetScale === null || presetScale === void 0 ? void 0 : presetScale.detectEnzymeApUl) !== null && _q !== void 0 ? _q : 0,
                    detectEnzymeHrpUl: (_r = presetScale === null || presetScale === void 0 ? void 0 : presetScale.detectEnzymeHrpUl) !== null && _r !== void 0 ? _r : 0,
                    enzyme: a.enzyme.enzyme.id,
                    channel: a.enzyme.channelNum
                }
            ]
        };
    };
    ManualProConsumerKitSerializer.serializeBuffers = function (b) {
        return {
            _type: 'manual',
            "hybridizationBufferMl": b.hybridization.valueMl,
            "probeWashBufferMl": b.probeWash.valueMl,
            'ampWashBufferMl': b.ampWash.valueMl
        };
    };
    return ManualProConsumerKitSerializer;
}());
export default ManualProConsumerKitSerializer;
//# sourceMappingURL=ManualProConsumerKitSerializer.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/manual-pro/ManualProConsumerKitSerializer.js
// module id = 595
// module chunks = 0